module.exports = __webpack_public_path__ + "img/icon65.c6d0ee63.png";